import React from 'react';

const BackIcon = () => (
  <svg viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.472771 6.72037L7.05651 0.475692C7.45986 0.0731466 8.06161 -0.0903009 8.62847 0.0487223C9.19532 0.187746 9.63813 0.607377 9.78519 1.14491C9.93226 1.68245 9.76047 2.25336 9.33642 2.63629L5.44457 6.32201H18.3881C19.2783 6.32201 20 7.00653 20 7.85093C20 8.69533 19.2783 9.37985 18.3881 9.37985H5.48057L9.33642 13.0428C9.9389 13.6441 9.92598 14.5914 9.3073 15.1777C8.68863 15.764 7.68991 15.7754 7.05651 15.2034L0.472771 8.95873C0.169365 8.67267 -0.000617981 8.28326 0.000787735 7.87749C-0.000263214 7.86486 -0.000263214 7.85218 0.000787735 7.83955C-0.00015831 7.82692 -0.00015831 7.81424 0.000787735 7.80161C0.000930786 7.39613 0.170677 7.00727 0.472771 6.72037Z"
      fill="#95A1B4"
    />
  </svg>
);

export default BackIcon;
